import React from 'react';
import { Modal } from 'react-bootstrap';
import QuestionItem from './QuestionItem';
import ClozeQuestionItem from './ClozeQuestionItem';
import { parseQuestionHTML } from 'utils/elearning.utils';
import { PrimaryButton } from 'design-system';

const QuestionReviewModal = ({ show, onHide, summary, onFinish, submitting = false }) => {
  return (
    <Modal
      size='lg'
      show={show}
      // Lúc đang submit (BE đang xử lý mod_quiz_process_attempt), KHÔNG
      // cho HV đóng modal: backdrop click + ESC + nút X đều bị chặn.
      // Tránh HV tưởng bấm sai → đóng → reload → mất context. Modal sẽ
      // tự đóng ở `finally` của handleFinishQuiz sau khi BE confirm.
      onHide={submitting ? () => {} : onHide}
      backdrop={submitting ? 'static' : true}
      keyboard={!submitting}
    >
      <Modal.Header closeButton={!submitting}>
        <Modal.Title>Xem lại câu trả lời</Modal.Title>
      </Modal.Header>
      <Modal.Body className='overflow-auto' style={{ maxHeight: '65vh' }}>
        {summary?.questions?.length > 0 ? (
          summary?.questions.map((q, index) => {
            // Câu cloze (mô phỏng) có shape khác — render bằng component riêng
            const parsed = parseQuestionHTML(q.html);
            const Item = parsed?.type === 'multianswer' ? ClozeQuestionItem : QuestionItem;
            return (
              <React.Fragment key={index}>
                <h5>Câu {q.number}</h5>
                <Item question={parsed} disabled={true} />
              </React.Fragment>
            );
          })
        ) : (
          <p>Không có câu hỏi nào để hiển thị.</p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <div className='d-flex justify-content-center w-100'>
          {/* Wrap onFinish() để KHÔNG forward MouseEvent → handleFinishQuiz
              dùng default param (timeUp=false). Trước đây `onClick={onFinish}`
              forward event → handleFinishQuiz(event) → timeUp = MouseEvent
              object → JSON.stringify({timeUp: event}) = `{}` xuống BE. */}
          <PrimaryButton
            size='lg'
            loading={submitting}
            loadingText='Đang nộp bài...'
            disabled={submitting}
            onClick={() => onFinish()}
          >
            Kết thúc bài làm
          </PrimaryButton>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default QuestionReviewModal;
